import { render, staticRenderFns } from "./AlbumPostList.vue?vue&type=template&id=525e63f6&scoped=true"
import script from "./AlbumPostList.vue?vue&type=script&lang=js"
export * from "./AlbumPostList.vue?vue&type=script&lang=js"
import style0 from "./AlbumPostList.vue?vue&type=style&index=0&id=525e63f6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525e63f6",
  null
  
)

export default component.exports